module.exports = __webpack_public_path__ + "static/media/logo-ktn@2x.58a8e46f.png";